import { useNavigate } from "react-router-dom"
import { Layout } from "../../../ui/layout"
import Button from "../../../ui/molecules/button"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { GenericBox } from "../components/genericBox"
import { GestioneAllegatiBox } from "../components/gestioneAllegatiBox"
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo"

export function Gestione() {
    const navigate = useNavigate()

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione']}
            noPaddingLat
            headerLabel="Gestione"
        >
            <div style={{ padding: '24px' }}>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    <div>
                        <GestioneAllegatiBox />
                    </div>
                    <div>
                        <GenericBox 
                            title="Gestione Tipologia Registri"
                            description="Creazione e modifica delle tipologie di registro"
                            onClick={() => navigate('/gestioneTipologiaRegistri')}
                            />
                    </div>
                    <div>
                        <GenericBox 
                            title="Gestione PAC"
                            description="Creazione dei Piani Annuali di Controllo (PAC)"
                            onClick={() => navigate('/gestionePAC')}
                            />
                    </div>
                    <div>
                        <GenericBox 
                            title="Gestione Prelievi"
                            description="Caricamento, assegnamento e modifica delle Buste per il prelievo dei campioni"
                            onClick={() => navigate('/gestionePrelievi')}
                            />
                    </div>
                    <div>
                        <GenericBox 
                            title="Gestione Organismi di Controllo"
                            description="Inserimento e modifica degli Organismi di Controllo"
                            onClick={() => navigate('/odc')}
                            />
                    </div>
                    <div>
                        <GenericBox 
                            title="Gestione Destinatari Provvedimento"
                            description="Inserimento e modifica dei destinatari del Provvedimento"
                            onClick={() => navigate('/measureRecipient')}
                            />
                    </div>
                    <div>
                        <GenericBox 
                            title="Gestione Scheda di Calcolo"
                            description="Inserimento e stampa di Scheda di Calcolo"
                            onClick={() => navigate('/schedaCalcoloAdmin')}
                            />
                    </div>
                    <div>
                        <GenericBox 
                            title="Gestione SOT"
                            description="Inserimento e stampa dei SOT"
                            onClick={() => navigate('/sot')}
                            />
                    </div>
                    <div>
                        <GenericBox 
                            title="Gestione Notifiche"
                            description="Caricamento delle notifiche"
                            onClick={() => navigate('/notificationAdmin')}
                            />
                    </div>
                </div>
            </div>
        </Layout>
    )
}